/**
 * Data Pipeline CSV Upload — Frontend ローカル Contract
 *
 * oz.file() を使用して OpenAPILink が File 検出時に
 * multipart/form-data を自動送信する。
 *
 * @standandforce/api-contract（Zod v3）では oz.file() が使えないため、
 * ファイルアップロードを伴う Contract は Frontend 側にローカル定義が必須。
 */
import { oc } from '@orpc/contract';
import { oz } from '@orpc/zod';
import { z } from 'zod';

export const dataPipelineCsvContract = oc.router({
  uploadCsv: oc
    .route({
      method: 'POST',
      path: '/v2/data-connector/data-pipelines/{id}/upload-csv',
    })
    .input(
      z.object({
        id: z.string(),
        file: oz.file(),
      }),
    )
    .output(z.void()),
});
